document.addEventListener('DOMContentLoaded', function () {
  const downloadPdfButton = document.querySelector('.download-pdf-button');

  function getPrintableMaterialResults() {
    const calculatorResult = window.FencingCalculatorResult;

    if (
      !calculatorResult ||
      !Array.isArray(calculatorResult.materialResults) ||
      calculatorResult.materialResults.length === 0
    ) {
      return [];
    }

    const materialCards = Array.from(
      document.querySelectorAll('#material-results .material-card')
    );

    return calculatorResult.materialResults.map(function (item, index) {
      const product = window.FencingProducts
        ? window.FencingProducts[item.name]
        : null;

      let variant = null;

      if (
        product &&
        Array.isArray(product.variants) &&
        product.variants.length > 0
      ) {
        if (window.FencingSelectedColour) {
          variant = product.variants.find(function (productVariant) {
            return (
              String(productVariant.title).trim() ===
              String(window.FencingSelectedColour).trim()
            );
          });
        }

        if (!variant) {
          variant = product.variants.find(function (productVariant) {
            return productVariant.available === true;
          });
        }

        if (!variant) {
          variant = product.variants[0];
        }
      }

      const productTitle =
        product && product.title
          ? product.title
          : item.name;

      const productImage =
        variant && variant.image
          ? variant.image
          : (
              product && product.image
                ? product.image
                : ''
            );

      const productPrice =
        variant && Number.isFinite(Number(variant.price))
          ? Number(variant.price)
          : Number(item.price || 0);

      let purchaseQuantity = Number(item.qty) || 0;

      if (materialCards[index]) {
        const quantityInput = materialCards[index].querySelector(
          '.material-purchase-qty'
        );

        if (quantityInput) {
          purchaseQuantity = Number(quantityInput.value) || 0;
        }
      }

      return {
        name: item.name,
        title: productTitle,
        image: productImage,
        requiredQty: Number(item.qty) || 0,
        purchaseQty: purchaseQuantity,
        unitPrice: productPrice,
        totalPrice: productPrice * purchaseQuantity
      };
    });
  }

  function buildBreakdownHtml(panelDetails) {
    if (
      !Array.isArray(panelDetails) ||
      panelDetails.length === 0
    ) {
      return `
        <p class="empty-text">
          No panel breakdown available.
        </p>
      `;
    }

    return panelDetails.map(function (panel, index) {
      const detailName =
        panel.detailName
          ? panel.detailName
          : `Panel ${index + 1}`;

      const detailUnit =
        panel.detailUnit
          ? panel.detailUnit
          : 'panel';

      const quantityText =
        panel.quantity === 1
          ? detailUnit
          : detailUnit + 's';

      const railText =
        Array.isArray(panel.railPieces) &&
        panel.railPieces.length > 0
          ? panel.railPieces.map(function (rail) {
              return `${rail.count} x ${rail.length}mmL`;
            }).join(', ')
          : '--';

      const gapSuffix =
        panel.gapSuffix !== undefined
          ? panel.gapSuffix
          : 'mm';

      return `
        <div class="breakdown-card">
          <div class="breakdown-card-header">
            <strong>
              ${detailName}: ${panel.width}mm x ${panel.height}mm
            </strong>

            <span>
              ${panel.quantity} ${quantityText}
            </span>
          </div>

          <div class="breakdown-grid">
            <div class="breakdown-item">
              <small>
                ${panel.gapLabel || 'Gap Size'}
              </small>

              <strong>
                ${panel.gap}${gapSuffix}
              </strong>
            </div>

            <div class="breakdown-item">
              <small>
                ${panel.productName || 'Product'}
              </small>

              <strong>
                ${
                  panel.productCount !== undefined
                    ? panel.productCount
                    : '--'
                }
                ${
                  panel.productLength
                    ? ` x ${panel.productLength}mmL`
                    : ''
                }
              </strong>
            </div>

            <div class="breakdown-item">
              <small>
                Frame
              </small>

              <strong>
                ${railText}
              </strong>
            </div>

            <div class="breakdown-item">
              <small>
                Screw
              </small>

              <strong>
                --
              </strong>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function buildMaterialsHtml(printableMaterials) {
    return printableMaterials.map(function (item) {
      return `
        <div class="print-material-card">
          <div class="print-material-image">
            ${
              item.image
                ? `
                  <img
                    src="${item.image}"
                    alt="${item.title}"
                  >
                `
                : `
                  <span>
                    Product Image
                  </span>
                `
            }
          </div>

          <div class="print-material-info">
            <strong class="print-material-title">
              ${item.title}
            </strong>

            <span>
              Required Qty: ${item.requiredQty}
            </span>

            <span>
              Purchase Qty: ${item.purchaseQty}
            </span>

            <span>
              $${item.unitPrice.toFixed(2)} ea.
            </span>

            <strong class="print-material-total">
              Total: $${item.totalPrice.toFixed(2)}
            </strong>
          </div>
        </div>
      `;
    }).join('');
  }

  function openPrintableResult() {
    const calculatorResult = window.FencingCalculatorResult;

    if (
      !calculatorResult ||
      !Array.isArray(calculatorResult.materialResults) ||
      calculatorResult.materialResults.length === 0
    ) {
      alert('Please calculate materials first.');
      return;
    }

    const printableMaterials = getPrintableMaterialResults();

    const panelDetails =
      Array.isArray(calculatorResult.panelDetails)
        ? calculatorResult.panelDetails
        : [];

    let grandTotal = 0;

    printableMaterials.forEach(function (item) {
      grandTotal += item.totalPrice;
    });

    const breakdownHtml = buildBreakdownHtml(panelDetails);
    const materialsHtml = buildMaterialsHtml(printableMaterials);

    const currentDate = new Date().toLocaleDateString('en-AU');

    const selectedSystem =
      window.FencingSelectedSystem || '';

    const selectedLayout =
      window.FencingSelectedLayout || '';

    const selectedColour =
      window.FencingSelectedColour || '';

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('Please allow pop-ups to view the printable result.');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>

      <html lang="en">
        <head>
          <meta charset="UTF-8">

          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          >

          <title>
            ELF WING Fencing Calculator Results
          </title>

          <link rel="stylesheet" href="${window.FencingPrintCssUrl}">

        </head>

        <body>

          <div class="print-page">

            <header class="print-header">

              <h1>
                Elf Wing Warehouse
              </h1>

              <h2>
                Fencing Calculator Results
              </h2>

              <div class="company-contact">
                info@elfwinggroup.com
                &nbsp; | &nbsp;
                1300 591 818 / 0433953663
              </div>

              <div class="print-date">
                Date: ${currentDate}
              </div>

            </header>


            <div class="project-summary">

              <div class="project-summary-item">
                <small>
                  System
                </small>

                <strong>
                  ${selectedSystem || '--'}
                </strong>
              </div>

              <div class="project-summary-item">
                <small>
                  Layout
                </small>

                <strong>
                  ${selectedLayout || '--'}
                </strong>
              </div>

              <div class="project-summary-item">
                <small>
                  Colour
                </small>

                <strong>
                  ${selectedColour || '--'}
                </strong>
              </div>

            </div>


            <section class="print-section">

              <h3 class="print-section-title">
                Panel Breakdown
              </h3>

              ${breakdownHtml}

            </section>


            <section class="print-section">

              <h3 class="print-section-title">
                Required Materials
              </h3>

              <div class="materials-grid">
                ${materialsHtml}
              </div>

            </section>


            <div class="total-box">

              <span class="total-label">
                Total Materials Cost:
              </span>

              <span class="total-value">
                $${grandTotal.toFixed(2)}
              </span>

              <span class="gst-text">
                (+GST)
              </span>

            </div>


            <div class="notes-box">

              <strong>
                Important Notes
              </strong>

              <p>
                Material quantities are calculated based on the dimensions and options entered in the ELF WING Fencing Calculator.
              </p>

              <p>
                This estimate is provided as a practical material guide. We recommend reviewing the measurements, quantities and selected options before placing the final order to ensure they match your project requirements.
              </p>

              <p>
                The prices shown are for uncut raw materials only. If you require pre-assembly, cutting, installation or other additional services, please contact us 1300 591 818 for a separate quotation.
              </p>
                 
              <p>
                Custom installations may require additional materials, fittings or hardware depending on site conditions and project requirements.
              </p>

            </div>


            <footer class="print-footer">

              Elf Wing Warehouse PTY LTD
              <br>

              www.elfwing.com.au
              &nbsp; | &nbsp;
              info@elfwinggroup.com
              &nbsp; | &nbsp;
              1300 591 818 / 0433953663

            </footer>


            <div class="print-actions no-print">

              <button
                type="button"
                class="print-button"
                onclick="window.print()"
              >
                Print / Save PDF
              </button>

            </div>

          </div>

        </body>
      </html>
    `);

    printWindow.document.close();
  }

  if (downloadPdfButton) {
    downloadPdfButton.addEventListener('click', function () {
      openPrintableResult();
    });
  }
});